var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.buttonClass,attrs:{"title":_vm.item.favourite ? 'Remove from favourites' : 'Add to favourites'},on:{"click":function($event){return _vm.toggleState()}}},[_c('b-icon',{attrs:{"pack":"mdi","icon":_vm.item.favourite ? 'heart' : 'heart-outline',"size":"is-small"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }